import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import {SlideRouterService} from '../slide-router.service';
import {trigger, transition, state, animate, style} from '@angular/animations';
import { SlideFragment } from '../slide-fragment';

const ATTR = 'slide-fragment-focus-container';
const ACTIVE_CLASSNAME = 'sub-fragment-active';
const INACTIVE_CLASSNAME = 'sub-fragment-inactive';

@Component({
  selector: '[sub-slide-fragment]',
  template: '<ng-content></ng-content>',
  styles: [`
    :host { display:block; }
  `]
})
export class SubSlideFragmentComponent implements SlideFragment {
  public element: any;
  private _left: number;
  private _top: number;
  private _container: any;

  @HostBinding('class.active')
  private _active: boolean = false;

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
  }

  ngOnInit() {
    this._container = getFocusContainer(this.element);
    const values = this._container.getAttribute(ATTR).split(',');
    const {left, top} = getElementCoordinatesWithinParent(this.element, this._container);
    if (values.indexOf('x') >= 0) {
      this._left = left;
    }
    if (values.indexOf('y') >= 0) {
      this._top = top;
    }
  }

  show() {
    if (!this._container) return;
    if (this._left) {
      this._container.style.left = `${this._left}px`;
    }
    if (this._top) {
      this._container.style.top = `${this._top}px`;
    }
    this.element.classList.add(ACTIVE_CLASSNAME);
    this.element.classList.remove(INACTIVE_CLASSNAME);
    this._active = true;
  }

  hide() {
    this._active = false;
    this.element.classList.remove(ACTIVE_CLASSNAME);
    this.element.classList.add(INACTIVE_CLASSNAME);
  }
}

function getFocusContainer(element: any) {
  const selector = '[' + ATTR + ']';
  let parent = element;
  while (parent) {
    if (parent.matches(selector)) return parent;
    parent = parent.parentElement;
  }
  return null;
}

function getElementCoordinatesWithinParent(element: any, parent: any): {left: number, top: number} {
  const coords = element.getBoundingClientRect();
  let h = document.body.clientHeight;
  let hh = Math.floor(h / 2);
  let w = document.body.clientWidth;
  let ww = Math.floor(w / 2);
  let left = ww - (coords.width / 2) - coords.left;
  let top = hh - (coords.height / 2) - coords.top;
  return {
    left, top
  };
}



// WEBPACK FOOTER //
// ./src/app/sub-slide-fragment/sub-slide-fragment.component.ts